import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import { useUser } from 'hooks';

import {
  conditionsAcceptedName,
  RegulationAcceptanceProps
} from 'pages/account/Register/pages/Main/steps/components/RegulationAcceptance';

import AcceptRegulationsWithInfoView from './AcceptRegulationsWithInfoView';

const AcceptRegulationsWithInfo = <T,>() => {
  const { regulationsAcceptanceRequired } = useUser();
  const formikContext = useFormikContext() as RegulationAcceptanceProps<T>;
  const { setFieldValue } = formikContext;
  useEffect(() => {
    if (regulationsAcceptanceRequired) {
      setFieldValue(conditionsAcceptedName, false);
    }
  }, [regulationsAcceptanceRequired]);

  if (!regulationsAcceptanceRequired) {
    return null;
  }
  return <AcceptRegulationsWithInfoView {...formikContext} />;
};

export default AcceptRegulationsWithInfo;
